import {LanguageDetail} from '@services/translation/language-detail';

export const LANGUAGES: LanguageDetail[] = [
  {
    flag: 'flag-de',
    name: 'German',
    key: 'de'
  },
  {
    flag: 'flag-en',
    name: 'English',
    key: 'en'
  },
  {
    flag: 'flag-es',
    name: 'Spanish',
    key: 'es'
  },
  {
    flag: 'flag-fr',
    name: 'French',
    key: 'fr'
  },
  {
    flag: 'flag-it',
    name: 'Italian',
    key: 'it'
  },
  {
    flag: 'flag-kr',
    name: 'Korean',
    key: 'ko-KR'
  },
  {
    flag: 'flag-pl',
    name: 'Polish',
    key: 'pl'
  },
  {
    flag: 'flag-tr',
    name: 'Turkish',
    key: 'tr'
  },
  {
    flag: 'flag-cn',
    name: 'Chinese',
    key: 'zh_CN'
  }
];